import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import * as Utils from '@core/utils';
import { Observable } from 'rxjs';
import { getCookie } from '@core/utils';
import { CNAME } from '@core/constants/cookies';
import { SNAME } from '@core/constants/storage';
import { WebAuthNVerificationRequest } from '@api/model/webAuthNVerificationRequest';
@Injectable()
export class AuthHeaderInterceptor implements HttpInterceptor {
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Adding this check because we need pass different token base on webauth type
    //  WebAuthNVerificationRequest.VerificationActionEnum => Register || Authenticate
    if (httpRequest.url.includes('verify-webauthn')) {
      console.log(httpRequest.body);
      return next.handle(
        httpRequest.clone({
          setHeaders: {
            Authorization: `Bearer ${
              httpRequest.body.verification_action === WebAuthNVerificationRequest.VerificationActionEnum.Authenticate
                ? localStorage.getItem(SNAME.USER_JWS)
                : Utils.getCookie(CNAME.PBB_UI_TOKEN) || ''
            }`,
          },
        })
      );
    }
    if (
      httpRequest.headers.get('Authorization') ||
      (httpRequest.url.includes('financial-institution') && httpRequest.method === 'GET') ||
      httpRequest.url.includes('pilot-otc')
    ) {
      return next.handle(httpRequest);
    }
    return next.handle(
      httpRequest.clone({
        setHeaders: {
          Authorization: `Bearer ${getCookie(CNAME.PBB_UI_TOKEN) || ''}`,
        },
      })
    );
  }
}
